/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

var EVENT_CODE = /* @__PURE__ */function (EVENT_CODE2) {
  EVENT_CODE2["left"] = "ArrowLeft";
  EVENT_CODE2["up"] = "ArrowUp";
  EVENT_CODE2["right"] = "ArrowRight";
  EVENT_CODE2["down"] = "ArrowDown";
  EVENT_CODE2["esc"] = "Escape";
  return EVENT_CODE2;
}(EVENT_CODE || {});

export { EVENT_CODE, EVENT_CODE as default };
//# sourceMappingURL=const.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/image-viewer/const.js
// module id = null
// module chunks = 